const collectionMobileNav = () => {
  const openNavEls = document.querySelectorAll('.collection-nav-mobile__open');
  const overlay = document.querySelector('.collection-nav-overlay');
  const closeNavEl = document.querySelector('.collection-nav-mobile__close');
  const collectionMenu = document.querySelector('.collection-products-section__collections__list');
  const body = document.body;
  const html = document.documentElement;

  const updateMenuViewport = () => {
    const header = document.querySelector('header');
    const headerBottom = header
      ? Math.max(0, Math.round(header.getBoundingClientRect().bottom))
      : 0;

    collectionMenu.style.top = `${headerBottom}px`;
    collectionMenu.style.height = `calc(100dvh - ${headerBottom}px)`;
  };

  if (openNavEls.length && overlay && closeNavEl && collectionMenu) {
    const openMenu = () => {
      if (collectionMenu.classList.contains('is-active')) {
        return;
      }

      const scrollY = window.scrollY;

      updateMenuViewport();
      body.dataset.collectionMenuScrollY = String(scrollY);
      body.style.position = 'fixed';
      body.style.top = `-${scrollY}px`;
      body.style.width = '100%';

      overlay.classList.add('is-active');
      collectionMenu.classList.add('is-active');
    };

    openNavEls.forEach((openNavEl) => {
      openNavEl.addEventListener('click', openMenu);
    });

    const closeMenu = () => {
      if (!collectionMenu.classList.contains('is-active')) {
        return;
      }

      const storedScrollY = Number.parseInt(body.dataset.collectionMenuScrollY || '0', 10);

      collectionMenu.style.top = '';
      collectionMenu.style.height = '';
      html.style.scrollBehavior = 'auto';
      body.style.position = '';
      body.style.top = '';
      body.style.width = '';
      delete body.dataset.collectionMenuScrollY;

      overlay.classList.remove('is-active');
      collectionMenu.classList.remove('is-active');

      window.scrollTo(0, storedScrollY);
      html.style.scrollBehavior = '';
    };

    closeNavEl.addEventListener('click', closeMenu);
    overlay.addEventListener('click', closeMenu);
    window.addEventListener('resize', () => {
      if (collectionMenu.classList.contains('is-active')) {
        updateMenuViewport();
      }
    });
  }
};

export default collectionMobileNav;